import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Sun: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m390 570c-99.25 0-180-80.75-180-180s80.75-180 180-180 180 80.75 180 180-80.75 180-180 180zm0-330c-82.71 0-150 67.29-150 150s67.29 150 150 150 150-67.29 150-150-67.29-150-150-150zm-210 150h-90v-30h60c16.57 0 30 13.43 30 30zm510 0h-90v-30h60c16.57 0 30 13.43 30 30zm-315-300v90h30v-60c0-16.57-13.43-30-30-30zm-188.64 75 63.64 63.64-21.21 21.21-42.43-42.43c-11.72-11.72-11.72-30.71 0-42.43zm428.49 21.21-63.64 63.64-21.21-21.21 42.43-42.43c11.72-11.72 30.71-11.72 42.43 0zm-21.21 428.79-63.64-63.64 21.21-21.21 42.43 42.43c11.72 11.72 11.72 30.71 0 42.43zm-428.49-21.36 63.64-63.64 21.21 21.21-42.43 42.43c-11.72 11.72-30.71 11.72-42.43 0zm209.85 96.36v-90h30v60c0 16.57-13.43 30-30 30z' />
  </IconBase>
));

Sun.displayName = 'Sun';

export default Sun;
